import { render, staticRenderFns } from "./menu-item-group.vue?vue&type=template&id=298185a2&scoped=true"
import script from "./menu-item-group.vue?vue&type=script&lang=ts"
export * from "./menu-item-group.vue?vue&type=script&lang=ts"
import style0 from "./menu-item-group.vue?vue&type=style&index=0&id=298185a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298185a2",
  null
  
)

export default component.exports